import React from 'react'

const SVG = ({
  style = {},
  fill = ['#999999', '#FFFFFF'],
  width = '100%',
  className = '',
  viewBox = '0 0 17 17'
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns='http://www.w3.org/2000/svg'
    className={`svg-icon ${className || ''}`}
  >
    <g>
      <g id='bgr'>
        <path
          fill={fill[0]}
          d='M8.5,0C13.2,0,17,3.8,17,8.5S13.2,17,8.5,17S0,13.2,0,8.5S3.8,0,8.5,0z'
        />
      </g>
      <path
        fill={fill[1]}
        d='M9.7,8.5l2.9-2.9c0.3-0.3,0.3-0.9,0-1.2s-0.9-0.3-1.2,0L8.5,7.3L5.6,4.4c-0.3-0.3-0.9-0.3-1.2,0
		s-0.3,0.9,0,1.2l2.9,2.9l-2.9,2.9c-0.3,0.3-0.3,0.9,0,1.2c0.2,0.2,0.4,0.2,0.6,0.2s0.4-0.1,0.6-0.2l2.9-2.9l2.9,2.9
		c0.2,0.2,0.4,0.2,0.6,0.2s0.4-0.1,0.6-0.2c0.3-0.3,0.3-0.9,0-1.2L9.7,8.5z'
      />
    </g>
  </svg>
)

export default SVG
